import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth is handled exclusively via httpOnly cookies set by the backend
// (POST /api/auth/login sets `access_token` cookie). We do NOT persist any
// token in localStorage to avoid XSS exfiltration risks.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
};
